<app-side-menu>
  <div class="products-container">
    <!-- Header Section -->
    <div class="header">
      <div class="header-content">
        <div class="title-section">
          <h1><i class="fa-solid fa-box"></i> Produtos</h1>
          <p>Gerencie seus produtos e planos</p>
        </div>
        <button *appHasPermission="'Products.Create'" class="btn-primary" (click)="navigateToNewProduct()">
          <i class="fa-solid fa-plus"></i>
          Novo Produto
        </button>
      </div>
    </div>

    <!-- Statistics Cards -->
    <div class="stats-grid">
      <div class="stat-card">
        <div class="stat-icon">
          <i class="fa-solid fa-box"></i>
        </div>
        <div class="stat-content">
          <h3>{{totalProductsCount}}</h3>
          <p>Total de Produtos</p>
        </div>
      </div>
      
      <div class="stat-card">
        <div class="stat-icon active">
          <i class="fa-solid fa-check-circle"></i>
        </div>
        <div class="stat-content">
          <h3>{{activeProductsCount}}</h3>
          <p>Produtos Ativos</p>
        </div>
      </div>
      
      <div class="stat-card">
        <div class="stat-icon inactive">
          <i class="fa-solid fa-pause-circle"></i>
        </div>
        <div class="stat-content">
          <h3>{{inactiveProductsCount}}</h3>
          <p>Produtos Inativos</p>
        </div>
      </div>
    </div>

    <!-- Filters Section -->
    <div class="filters-section">
      <div class="filters-row">
        <div class="filter-group">
          <label for="selectedType">Tipo:</label>
          <select 
            id="selectedType"
            [(ngModel)]="selectedType" 
            class="form-control">
            <option *ngFor="let type of productTypes" [value]="type.value">{{type.label}}</option>
          </select>
        </div>
        
        <div class="filter-group">
          <label for="selectedStatus">Status:</label>
          <select 
            id="selectedStatus"
            [(ngModel)]="selectedStatus" 
            class="form-control">
            <option *ngFor="let option of statusOptions" [value]="option.value">
              {{option.label}}
            </option>
          </select>
        </div>
      </div>
    </div>

    <!-- Products Table -->
    <div class="products-table-container">
      <!-- Loading State -->
      <div *ngIf="isLoading" class="loading-state">
        <i class="fa-solid fa-spinner fa-spin"></i>
        <p>Carregando produtos...</p>
      </div>

      <!-- Tabela Genérica -->
      <div *ngIf="!isLoading && filteredProducts.length > 0">
        <app-table
          [title]="'Lista de Produtos'"
          [data]="filteredProducts"
          [columns]="columns"
          [loading]="isLoading"
          [showSearch]="true"
          [searchPlaceholder]="'Buscar por código, nome ou descrição...'"
          [clickable]="false"
          [actions]="actions"
          [useDropdownMenu]="true"
          [enableSorting]="true"
          (sortChange)="onSortChange($event)"
          (actionClick)="onActionClick($event)">
        </app-table>
      </div>

      <!-- Empty State -->
      <div *ngIf="!isLoading && filteredProducts.length === 0" class="empty-state">
        <i class="fa-solid fa-box-open"></i>
        <h3>Nenhum produto encontrado</h3>
        <p *ngIf="selectedType || selectedStatus">
          Tente ajustar os filtros ou criar um novo produto
        </p>
        <p *ngIf="!selectedType && !selectedStatus">
          Crie seu primeiro produto para começar
        </p>
        <button *appHasPermission="'Products.Create'" class="btn-primary" (click)="navigateToNewProduct()">
          <i class="fa-solid fa-plus"></i>
          Criar Primeiro Produto
        </button>
      </div>
    </div>
  </div>
</app-side-menu>
